/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'external-link': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2 7.188a2.375 2.375 0 012.375-2.375h4.688a.5.5 0 010 1H4.375C3.615 5.813 3 6.428 3 7.188v8.437C3 16.385 3.616 17 4.375 17h8.438c.759 0 1.374-.616 1.374-1.375v-4.688a.5.5 0 011 0v4.688A2.375 2.375 0 0112.813 18H4.374A2.375 2.375 0 012 15.625V7.187z" _fill="#1F222C"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M17.854 2.146a.5.5 0 010 .708l-9.375 9.375a.5.5 0 01-.708-.708l9.375-9.375a.5.5 0 01.708 0z" _fill="#1F222C"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M12.313 2.5a.5.5 0 01.5-.5H17.5a.5.5 0 01.5.5v4.688a.5.5 0 01-1 0V3h-4.188a.5.5 0 01-.5-.5z" _fill="#1F222C"/>'
  }
})
